export default __webpack_public_path__ + "static/media/userUpdateImg.4e59faf6.svg";